import { POWaitingPaymentDetail } from './po-waiting-payment.component';

export default POWaitingPaymentDetail;
